var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"active":"","title":"Progress Bar Settings"}},[(_vm.linked)?_c('b-form-group',[_c('button',{staticClass:"flex p-0 text-[11px] hover:bg-gray-100 items-center text-dark border rounded-[4px] w-[114px] h-[30px] justify-content-center gap-[5px] cursor-pointer font-[500] hover:text-[#3D82EA] text-[#7E7E7E]",on:{"click":() => _vm.unlinkSid()}},[_vm._v(" Unlink Styles "),_c('i',{staticClass:"fa fa-link text-primary"})])]):_vm._e(),_c('sid-background',{attrs:{"sid":`.--${_vm.section.sid}--progress`}}),_c('sid-background',{attrs:{"label":"Bar Color","sid":`.--${_vm.section.sid}--bar`}}),_c('b-form-group',{attrs:{"label":"Progress","label-class":"!pb-[3px]"}},[_c('b-row',{staticClass:"align-items-center",attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"pr-2",attrs:{"cols":"9"}},[_c('vue-slider',{staticClass:"editor-slider-1 px-2",attrs:{"dot-size":17,"max":parseInt(_vm.config.max),"min":0,"tooltip":"none"},model:{value:(_vm.config.value),callback:function ($$v) {_vm.$set(_vm.config, "value", $$v)},expression:"config.value"}})],1),_c('b-col',{attrs:{"cols":"3"}},[_c('b-input',{attrs:{"max":100,"min":0,"type":"number"},model:{value:(_vm.config.value),callback:function ($$v) {_vm.$set(_vm.config, "value", $$v)},expression:"config.value"}})],1)],1)],1),_c('sid-width-and-height',{attrs:{"sid":`.--${_vm.section.sid}--progress`}}),_c('b-form-group',[_c('b-checkbox',{model:{value:(_vm.config.animated),callback:function ($$v) {_vm.$set(_vm.config, "animated", $$v)},expression:"config.animated"}},[_vm._v(" Animated ")])],1),_c('b-form-group',{attrs:{"label":"Text"}},[_c('b-input',{model:{value:(_vm.config.text),callback:function ($$v) {_vm.$set(_vm.config, "text", $$v)},expression:"config.text"}})],1),_c('sid-font',{attrs:{"sid":`.--${_vm.section.sid}--bar`,"rule-name":"font"}}),_c('sid-range-slider',{attrs:{"label":"Font Size","rule-name":"font-size","sid":`.--${_vm.section.sid}--bar`}}),_c('sid-range-slider',{attrs:{"label":"Letter Spacing","rule-name":"letter-spacing","sid":`.--${_vm.section.sid}--bar`}}),_c('sid-align',{attrs:{"sid":`.--${_vm.section.sid}--text`,"rule-name":"justify-content","label":"Text Alignment"}}),_c('sid-range-slider',{attrs:{"label":"Text Gap","rule-name":"padding","min":0,"sid":`.--${_vm.section.sid}--text`,"default-dimension":"px","dimensions":['px']}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Decoration")]),_c('sid-font-style',{attrs:{"sid":`.--${_vm.section.sid}--bar`,"rule-name":"font"}})],1)])],1),_c('SidbearSettingsGroup',{attrs:{"title":"Border & Radius"}},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":`.--${_vm.section.sid}--progress`,"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":`.--${_vm.section.sid}--progress`,"label":"Border Width","rule-name":"border","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":`.--${_vm.section.sid}--progress`,"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":`.--${_vm.section.sid}--progress`,"rule-name":"border","angles":[
        {
          text: '',
          value: 'top-left-radius'
        },
        {
          text: '',
          value: 'top-right-radius'
        },
        {
          text: '',
          value: 'bottom-left-radius'
        },
        {
          text: '',
          value: 'bottom-right-radius'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Drop Shadow"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":`.--${_vm.section.sid}--progress`,"rule-name":"box-shadow"}})],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Padding & Margins"}},[_c('sid-linked-group',{attrs:{"label":"Padding","sid":`.--${_vm.section.sid}--wrapper`,"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}}),_c('sid-linked-group',{attrs:{"label":"Margin","sid":`.--${_vm.section.sid}--wrapper`,"rule-name":"margin","min":-2000,"max":2000,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }